import { Alert } from "antd";
import { Link } from "react-router-dom";

const Info = (props) => {
    const { infoDescription, heading, label, icon, linkEnabled, infoLinks } = props
    
    const handleLinkClick = (link) => {
        window.open(link, "_blank")
    }

    // Function to convert markdown-like syntax to HTML
    const convertMarkdownToHtml = (text) => {
        if (!text) return '';
        
        let html = text
            // Convert **bold** to <strong>
            .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
            // Convert *italic* to <em>
            .replace(/\*(.*?)\*/g, '<em>$1</em>')
            // Convert ~~strikethrough~~ to <del>
            .replace(/~~(.*?)~~/g, '<del>$1</del>')
            // Keep existing HTML tags (like <u>, <strong>, <em>, etc.)
            // Convert line breaks to <br>
            .replace(/\n/g, '<br>')
            // Handle ordered lists (1. item)
            .replace(/^(\d+\.\s+)(.*?)$/gm, '<li>$2</li>')
            // Handle unordered lists (- item or * item)
            .replace(/^[-*]\s+(.*?)$/gm, '<li>$1</li>');
            
        // Wrap consecutive list items in <ol> or <ul>
        if (html.includes('<li>')) {
            // Check if original text had numbered lists
            const hasNumberedList = text.match(/^\d+\.\s+/m);
            const hasBulletList = text.match(/^[-*]\s+/m);
            
            if (hasNumberedList) {
                html = html.replace(/(<li>.*?<\/li>(\s*<li>.*?<\/li>)*)/gs, '<ol>$1</ol>');
            } else if (hasBulletList) {
                html = html.replace(/(<li>.*?<\/li>(\s*<li>.*?<\/li>)*)/gs, '<ul>$1</ul>');
            }
            
            // Clean up nested list tags
            html = html.replace(/<\/ol>\s*<ol>/g, '').replace(/<\/ul>\s*<ul>/g, '');
        }
            
        return html;
    };

    // Function to render HTML content safely
    const renderHtmlContent = (htmlString) => {
        if (!htmlString) return null;
        return <div dangerouslySetInnerHTML={{ __html: htmlString }} />;
    };

    // Improved function to check if content is HTML
    const isHtmlContent = (content) => {
        if (!content || typeof content !== 'string') return false;
        
        // Check for HTML tags (including paragraph, div, span, etc.)
        const htmlTagPattern = /<\/?[a-z][\s\S]*>/i;
        return htmlTagPattern.test(content);
    };

    const infoContent = (
        <>
        { infoDescription && (
            <div className="info-description" style={{
                lineHeight: '1.5',
                wordWrap: 'break-word'
            }}>
                <style>{`
                    .info-description ul {
                        list-style-type: disc !important;
                        padding-left: 20px !important;
                        margin: 8px 0 !important;
                    }
                    .info-description ol {
                        list-style-type: decimal !important;
                        padding-left: 20px !important;
                        margin: 8px 0 !important;
                    }
                    .info-description li {
                        display: list-item !important;
                        margin: 4px 0 !important;
                        list-style-position: outside !important;
                    }
                    .info-description p {
                        margin: 8px 0 !important;
                    }
                    .info-description strong {
                        font-weight: bold !important;
                    }
                    .info-description em {
                        font-style: italic !important;
                    }
                    .info-description u {
                        text-decoration: underline !important;
                    }
                    .info-description del {
                        text-decoration: line-through !important;
                    }
                `}</style>
                {isHtmlContent(infoDescription)
                    ? renderHtmlContent(infoDescription)
                    : (typeof infoDescription === 'string' && (
                        infoDescription.includes('**') || 
                        infoDescription.includes('*') || 
                        infoDescription.includes('~~')
                    ))
                        ? renderHtmlContent(convertMarkdownToHtml(infoDescription))
                        : infoDescription
                }
            </div>
        )}
        {
            linkEnabled && infoLinks && infoLinks.length > 0 ? 
            infoLinks.map((link, index) => {
                return <div key={`info-link-${index}`} onClick={() => handleLinkClick(link.link)} style={{ color: "#1677ff", cursor: "pointer" }}>{link.label}</div>
            })
            : null
        }
        </>
    )

    // Only show the message (heading) if heading is enabled AND label exists
    const messageText = (heading && label) ? label : "";

    return (
        <>
            <div className="form-element">
                <Alert showIcon={icon} message={messageText} description={infoContent} />
            </div>
        </>
    )
}

export default Info